<script setup lang="ts">
import { ref, watch, reactive } from 'vue';
// import { useForm } from 'vee-validate';

import StepsPanel from '@/components/agent-feedback/StepsPanel.vue';
import ClaimOverviewForm from '@/components/forms/create-claim/1-ClaimOverview.vue'
import FlightForm from '@/components/forms/create-claim/2-Itinerary.vue'
import PassengersForm from '@/components/forms/create-claim/3-Passengers.vue'
import NotesForm from '@/components/forms/create-claim/4-Notes.vue'
import DocumentsForm from '@/components/forms/create-claim/5-Documents.vue'

import {useVuelidate} from '@vuelidate/core'
import {helpers, required, requiredIf} from '@vuelidate/validators'
import adminAPI from "@/services/api";
import BaseButton from '@/components/ui/buttons/BaseButton.vue';
import {FolderPlusIcon} from '@heroicons/vue/24/solid';
import { ClaimTypeName } from '@/utils/config/constants'
import { scrollToTop } from '@/utils';
import { useNotificationStore } from '@/store';
import StepsSimple from '@/components/agent-feedback/StepsSimple.vue';
import StepsFull from '@/components/agent-feedback/StepsFull.vue';
//import Test from './Test.vue';

const form = ref({
  reservation: {
    pnrId: "",
    officeId: "",
  },
  claim: {
    claimType: "FLIGHT_DELAY" as ClaimTypeName,
    ec261CompensationAmount: 0,
    cancellationNotice: "NOT_NOTIFIED",
    delayedTimeValid: null,
  },
  flight: {
    flightIdentifier: "",
    departureAirportIATA: "",
    arrivalAirportIATA: "",
    schedule: {
      inGateArrivalLocal: null,
      scheduledArrivalLocal: null,
      actualDepartureLocal: null,
      scheduledDepartureLocal: null,
    },
    utcHourFormat: true
  },
  passengers: [],
  note: ''
});

async function updatePassengers(passenger) {
  form.value.passengers = passenger
  await v$.value.passengers['passengers'].$validate()
}


async function checkError() {
  await steps[currentStep.value].validate()
  return v$.value.$errors.length === 0;
}

const formResponse = ref();
async function submitClaimForm() {
  // if (!await checkError()) {
  //   return
  // }
  // form.value.flight.scheduledDepartureLocal = form.value.flight.scheduledDepartureUTC
  // form.value.flight.scheduledDepartureLocal = form.value.flight?.scheduledArrivalUTC;
  const waitNotif = useNotificationStore().emitNotification({
    type: "wait",
    title: "Dossier en cours de création",
  })
  formResponse.value = await adminAPI.createExternalClaim(form.value as any);
  waitNotif.duration = 0;
  useNotificationStore().emitNotification({ title: "Dossier créé avec succès" });
  scrollToTop();
  currentStep.value++;
}

function isInPast(value) {
  if (!value) return true;
  const selectedDate = new Date(value);
  const currentDate = new Date();
  return selectedDate < currentDate;
}

const rules = {
  reservation: {
    pnrId: {
      required: helpers.withMessage('Veuillez entrer une valeur', required),
      alphaNumeric: helpers.withMessage('La valeur doit être un numéro de PNR (exemple: J5XTP2)', helpers.regex(/^[A-Z0-9]{5,8}$/))
    },
    officeId: { required }
  },
  claim: {
    claimType: {required},
    cancellationNotice: {required: requiredIf(() => form.value.claim?.claimType === "FLIGHT_CANCELLATION")},
    delayedTimeValid: {required: requiredIf(() => form.value.claim?.claimType === 'FLIGHT_DELAY')}
  },
  flight: {
    schedule: {
      scheduledArrivalLocal: {
        required: helpers.withMessage("Merci d'indiquer l'horaire d'arrivée prévu", required),
        // isInPast: helpers.withMessage('La date de départ doit être dans le passé', isInPast)
      },
      scheduledDepartureLocal: {
        required: helpers.withMessage("Merci d'indiquer l'horaire de départ prévu", required),
        // isInPast: helpers.withMessage('La date d\'arrivée doit être dans le passé', isInPast)
      },
      inGateArrivalLocal: {
        required: helpers.withMessage("Merci d'indiquer l'horaire d'arrivée", requiredIf(() => form.value.claim?.claimType === "FLIGHT_DELAY"))
        
      }
    },
    flightIdentifier: {
      required: helpers.withMessage('Veuillez entrer le numéro de vol', required),
      alphaNumeric: helpers.withMessage('La valeur doit être un numéro de vol (exemple: BA026)', helpers.regex(/^([A-Z][\d]|[\d][A-Z]|[A-Z]{2,3})(\d{1,})$/))
    },
    departureAirportIATA: {required: helpers.withMessage('Veuillez sélectionner l\'aéroport de départ', required)},
    arrivalAirportIATA: {required: helpers.withMessage('Veuillez sélectionner l\'aéroport d\'arrivée', required)},
    utcHourFormat: {}
  },
  passengers: { required },
  note: { required }
}

const steps = [
  {
    name: "Réservation",
    description: null,
    stepNumber: 0,
    form: ClaimOverviewForm,
    validate: async () => {
      await v$.value.claim.$validate();
      await v$.value.reservation.$validate();
    }
  },
  {
    name: "Destination",
    description: null,
    stepNumber: 1,
    form: FlightForm,
    validate: async () => {
      await v$.value.flight.$validate();
    }
  },
  {
    name: "Passagers",
    description: null,
    stepNumber: 2,
    form: PassengersForm,
    validate: async () => {
      const valid = await v$.value.passengers.$validate();
      if (!valid) {
        useNotificationStore().emitNotification({
          type: "info",
          title: "Merci d'ajouter au moins 1 passager pour continuer",
        }, 6000)
      }
    }
  },
  {
    name: "Note",
    description: null,
    stepNumber: 3,
    form: NotesForm,
    validate: async () => {
      await v$.value.note.$validate(); 
    }
  },
];
const currentStep = ref(0);

const v$ = useVuelidate(rules, form);
// @ts-ignore
// watch(currentStep, (step) => v$.value = useVuelidate(steps[step].rules, form))

async function nextStep() {
  if (!await checkError()) {
    return;
  }
  scrollToTop();
  currentStep.value++;
  useNotificationStore().emitNotification({
    title: "Éléments enregistrés avec succès",
    type: "success",
  }, 5000)
}
</script>
<template>
<div>
  <div class="w-full mx-auto ">
    <StepsPanel :steps="steps" :current-step="currentStep" />
  </div>
  <div class="p-8">

    <!-- <Test /> -->

    <div class="h-auto pt-12 my-auto">
      <!-- <component :is="steps[currentStep].form"  @nextStep="nextStep" /> -->
      <!-- <pre class="text-left">{{ form }}</pre> -->
      <!-- <pre class="text-left">{{ v$.note }}</pre> -->

      <ClaimOverviewForm v-show="currentStep === 0"
        :claim="v$.claim?.$model"
        :reservation="v$.reservation?.$model"
        :errors="v$.$errors"
      />
      <FlightForm v-show="currentStep === 1"
        :show-actual-schedule="!(form.claim.claimType.includes('CANCEL'))"
        :flight="v$.flight?.$model"
        :errors="v$.$errors"
      />
      <PassengersForm v-show="currentStep === 2" @update:passengers="updatePassengers"/>
      <!-- <PassengersForm v-show="currentStep === 2" @update:passengers="updatePassengers" :errors="v$.$errors"/> -->
      <NotesForm v-show="currentStep === 3" :note="v$.note" />
      <DocumentsForm v-show="currentStep === 4" :create-claim-response="formResponse" />
    </div>
    <div v-if="currentStep < 4" class="flex items-center justify-end py-4 pl-4 gap-x-6 sm:pl-8">
      <BaseButton v-if="currentStep"  @click="currentStep--" text="Précédent" size="lg"/>
      <BaseButton v-if="currentStep === steps.length - 1" type="submit" @click="submitClaimForm" text="Valider" :disabled="v$.$errors.length > 0" size="lg"/>
      <BaseButton v-else type="submit" @click="nextStep" text="Suivant" :disabled="v$.$errors.length > 0" size="lg"/>
    </div>
  </div>
</div>
</template>